import React, { useEffect, useRef, useState } from "react";
import Table from "../../components/common/table/Table";
import Button from "../../components/common/ui/Button";
import { useDispatch, useSelector } from "react-redux";
import { history } from "../../_helpers";
import { inmateAction } from "../../_store";
import { useLocation } from "react-router-dom";
import { TextInput } from "../../components/common/ui/Inputs";
import CustomLoader from "../../components/common/ui/Loader";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication";

const InmateTransaction = () => {
  const { commonFacilityCode: facilityCode } = useSelector(
    (state) => state.auth
  );

  const { transactionDeatils, loading } = useSelector((state) => state.inmate);

  const [tableData, setTableData] = useState();
  const [publicUserName, setPublicUserName] = useState("");
  const [inmateUserName, setInmateUserName] = useState("");
  const [totalRecordCount, setTotalRecordCount] = useState(0);
  useEffect(() => {
    if (transactionDeatils?.DataList?.length > 0) {
      dispatch(inmateAction.clearTransactionDeatils());
      if (!publicUserName && transactionDeatils?.DataList[0]?.PublicUserName) {
        setPublicUserName(transactionDeatils?.DataList[0]?.PublicUserName);
      }
      if (!inmateUserName && transactionDeatils?.DataList[0]?.InmateFullName) {
        setInmateUserName(transactionDeatils?.DataList[0]?.InmateFullName);
      }
      if (transactionDeatils?.TotalRecordCount) {
        setTotalRecordCount(transactionDeatils?.TotalRecordCount);
      }
      setTableData(
        transactionDeatils?.DataList?.length > 0
          ? transactionDeatils?.DataList
          : []
      );
    }
  }, [transactionDeatils]);
  const dispatch = useDispatch();

  //Getting this InmateID from InmateList Page
  const location = useLocation();
  const { inmate: Inmate } = location.state || {};
  // Adding a reference to the search input to manage focus
  const searchInputRef = useRef(null);

  const [transaction, setTransaction] = useState({
    CreditDebitID: 0,
    UserID: 0,
    InmateID: 0, //InmateID
    PublicUserID: 0, //PublicUserID
    PUIConnectionID: 0, // PUIConnectionID
    FacilityID: 0, //FacilityID
    TransactionFromDate: "", //TransactionFromDate
    TransactionToDate: "", //TransactionToDate
    SortBy: "TransactionDate DESC", //SortBy
    PageNo: 1,
    RowCountPerPage: 10,
    AllSearch: "",
  });

  useEffect(() => {
    if (Inmate?.InmateID) {
      dispatch(inmateAction.clearTransactionDeatils());
      setTransaction((prev) => ({
        ...prev,
        InmateID: Inmate?.InmateID,
      }));
      dispatch(
        inmateAction.LoadCreditDebitTransactionDetails({
          ...transaction,
          InmateID: Inmate?.InmateID,
          // PublicUserID: Inmate?.PublicUserID,
        })
      );
    }
  }, [Inmate]);

  useEffect(() => {
    if (Inmate) {
      dispatch(
        inmateAction.LoadCreditDebitTransactionDetails({
          ...transaction,
          InmateID: Inmate?.InmateID,
          // PublicUserID: Inmate?.PublicUserID,
        })
      );
    }
  }, [transaction.PageNo, transaction.RowCountPerPage]);

  // const handleSearchTerm = (e) => {
  //   let { value } = e.target;

  //   // if (value.trim() === "") return;

  //   // AllSearch
  //   setTransaction((prev) => ({
  //     ...prev,
  //     AllSearch: value,
  //     PageNo: 1,
  //     RowCountPerPage: 10,
  //   }));
  // };

  const handleSearchTerm = (e) => {
    let { value } = e.target;
    // Remove only leading spaces (if any)
    if (value.length === 1 && value === " ") return;
    value = value.replace(/^\s+/, "");

    setTransaction((prev) => ({
      ...prev,
      AllSearch: value,
      // PageNo: 1,
      // RowCountPerPage: 10,
    }));
  };

  const handleTransactionSearch = (e) => {
    // if (e.key === "Enter") {
    // setDebouncedSearchTerm(searchTerm); // Trigger the API call here
    const search = { ...transaction };
    search.PageNo = 1;
    search.RowCountPerPage = 10;
    search.InmateID = Inmate?.InmateID;
    setTransaction(search);
    dispatch(inmateAction.LoadCreditDebitTransactionDetails(search))
      .then((result) => {
        const data = result?.payload?.DataList || [];
        dispatch(inmateAction.clearTransactionDeatils());
        if (!publicUserName && data[0]?.PublicUserName) {
          setPublicUserName(data[0]?.PublicUserName);
        }
        if (!inmateUserName && data[0]?.InmateFullName) {
          setInmateUserName(data[0]?.InmateFullName);
        }
        if (transactionDeatils?.TotalRecordCount) {
          setTotalRecordCount(transactionDeatils?.TotalRecordCount);
        }
        setTableData(data?.length > 0 ? data : []);
      })
      .catch((err) => {
        showToastNotification("Failed to fetch transaction details", "error");
      });
    // }
  };

  const column = [
    {
      name: "Amount($)",
      key: "CurrentBalance",
      selector: (row) => row.CurrentBalance.toFixed(2),
      sortable: true,
    },
    {
      name: "Credit Debit ID",
      key: "CreditDebitID",
      selector: (row) => row.CreditDebitID,
      sortable: true,
    },
    {
      name: "Credit $ (+)",
      key: "CreditAmount",
      selector: (row) => row.CreditAmount.toFixed(2),
      sortable: true,
    },
    {
      name: "Debit $ (-)",
      key: "DebitAmount",
      selector: (row) => row.DebitAmount.toFixed(2),
      sortable: true,
    },
    {
      name: "Purpose",
      key: "TransactionPurpose",
      selector: (row) => row.TransactionPurpose,
      sortable: true,
    },
    {
      name: "Date",
      key: "TransactionDate",
      selector: (row) => row.TransactionDate,
      sortable: true,
    },
  ];

  const handlePageChange = (value) => {
    if (isSorting) {
      isSorting = false;
      return;
    }
    setTransaction((prev) => ({
      ...prev,
      PageNo: value,
    }));

    // Calculate the correct slice for pagination
    // const startIndex = (value - 1) * transaction?.RowCountPerPage; // Starting index of slice
    // const endIndex = startIndex + transaction?.RowCountPerPage; // Ending index of slice

    // setTableData(
    //   searchTerm?.length > 0
    //     ? filteredData?.length
    //       ? filteredData.slice(startIndex, endIndex)
    //       : []
    //     : transactionDeatils?.DataList?.length
    //     ? transactionDeatils?.DataList?.slice(startIndex, endIndex)
    //     : []
    // );
  };

  const handleRowPerPage = (value) => {
    setTransaction((prev) => ({
      ...prev,
      PageNo: 1,
      RowCountPerPage: value,
    }));
  };

  let isSorting = false;
  const handleSort = (column, sortDirection) => {
    if (!column?.key) return;
    isSorting = true;
    const search = { ...transaction };
    const newSortOrder = search?.SortBy.includes(column.key)
      ? search.SortBy.endsWith("asc")
        ? "desc"
        : "asc"
      : "asc";

    search.SortBy = `${column.key} ${newSortOrder}`;
    search.PageNo = transaction?.PageNo;
    // search.PublicUserID = Inmate?.PublicUserID;
    // search.FacilityID = facilityCode;
    setTransaction(search);
    dispatch(
      inmateAction.LoadCreditDebitTransactionDetails({
        ...transaction,
        InmateID: Inmate?.InmateID,
        // PublicUserID: Inmate?.PublicUserID,
        SortBy: search.SortBy,
      })
    );
  };

  if (loading) {
    return <CustomLoader />;
  }

  return (
    <div>
      <div className="p-2 ">
        <div className="d-flex flex-wrap justify-content-between align-items-center flex-wrap ">
          <h4 className=" inner-subheader-bg text-color">
            <i class="fa-solid fa-receipt me-2"></i>Transactions
          </h4>
          <Button
            label="Back"
            icon={"fa-solid fa-angle-left"}
            type="button"
            status="primary"
            onClick={() => {
              history.navigate("/Admin/InmateList");
              dispatch(inmateAction.setInmateCurrentTab("inmate-info-tab"));
            }}
          />
        </div>
      </div>
      <div className="card shadow-sm b-r-all p-3 border border-dark-grey mt-1 w-100">
        <div className="d-flex flex-wrap justify-content-between align-items-center flex-wrap">
          <h2 className="text-color form_title_uppercase">Purchase History</h2>
        </div>

        {/* First Row: Username, Last Name, First Name */}
        <div className="row">
          <div className="p-2 m-0 d-flex flex-wrap align-items-center">
            {/* Frequency */}
            <div className="col-md-4 d-flex flex-wrap align-items-center me-4">
              <label className="fs-5" style={{ minWidth: "150px" }}>
                Public User :
              </label>
              <strong className="fs-5 text-end">
                {/* {transactionDeatils && transactionDeatils[0]?.PublicUserName} */}
                {publicUserName}
              </strong>
            </div>

            {/* Limit */}
            <div className="col-md-4 d-flex flex-wrap align-items-center">
              <label className="fs-5" style={{ minWidth: "150px" }}>
                Inmate Name :
              </label>
              <strong className="fs-5 text-end">
                {/* {transactionDeatils && transactionDeatils[0]?.InmateFullName} */}
                {inmateUserName}
              </strong>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-3">
        <div className="d-flex flex-wrap  justify-content-end mb-3">
          {/* <ExcelExport variant="soft-gray" handleExcelExport={handleExcel} /> */}
        </div>
        {/* Table Section */}

        {/* <div className="row">
          <div className="mb-3 col-sm-6 col-md-6 col-lg-6 ">
            <TextInput
              ref={searchInputRef} // Attach the ref here
              type="text"
              placeholder="Search..."
              // value={searchTerm}
              value={transaction?.AllSearch}
              //   handleChange={(e) => setSearchTerm(e.target.value)}
              handleChange={(e) => handleSearchTerm(e)}
              onKeyDown={handleKeyDown} // Listen for the "Enter" key
            />
            <Button
              variant="primary"
              className="me-2"
              label={"SEARCH"}
              type={"submit"}
              status={"primary"}
              disabled={false}
              icon={"search"}
            />

            <Button
              variant="secondary"
              className="me-2"
              // onClick={handleSearchReset}
              label={"RESET"}
              type={"button"}
              status={"secondary"}
              disabled={false}
              icon={"fa-solid fa-rotate-right"}
            />
          </div>
        </div> */}

        <form className="row" onSubmit={() => handleTransactionSearch()}>
          {/* Search Input */}
          <div className="col-12 col-md-6 mb-2">
            <TextInput
              ref={searchInputRef}
              type="text"
              placeholder="Search..."
              value={transaction?.AllSearch}
              handleChange={handleSearchTerm}
            // onKeyDown={handleKeyDown}
            />
          </div>

          {/* Buttons */}
          <div className="col-12 col-md-6 d-flex flex-wrap align-items-start gap-2 mb-2">
            <Button
              variant="primary"
              label="SEARCH"
              type="submit"
              status="primary"
              disabled={false}
              icon="search"
            />
            <Button
              variant="secondary"
              label="RESET"
              type="reset"
              status="secondary"
              disabled={false}
              icon="fa-solid fa-rotate-right"
              onClick={() => {
                const search = { ...transaction };
                search.AllSearch = "";
                search.PageNo = 1;
                search.RowCountPerPage = 10;
                setTransaction(search);

                // setTransaction((prev) => ({
                //   ...prev,
                //   AllSearch: "",
                //   PageNo: 1,
                //   RowCountPerPage: 10,
                // }));
                dispatch(
                  inmateAction.LoadCreditDebitTransactionDetails({
                    ...search,
                    InmateID: Inmate?.InmateID,
                    // PublicUserID: Inmate?.PublicUserID,
                  })
                );
              }}
            />
          </div>
        </form>

        <Table
          columns={column}
          data={tableData}
          pagination={true}
          onChangePage={handlePageChange} // Call API when page changes
          onChangeRowsPerPage={handleRowPerPage}
          // totalRowCount={
          //   filteredData && searchTerm?.length > 0
          //     ? filteredData?.length
          //     : transactionDeatils?.length
          // }
          totalRowCount={totalRecordCount}
          currentPage={transaction?.PageNo}
          paginationPerPage={transaction?.RowCountPerPage}
          onSort={handleSort}
          serverSideSort
          sortColumn={transaction?.SortBy.split(" ")[0]}
          sortDirection={transaction?.SortBy.split(" ")[1]}
        //   paginationRowsPerPageOptions = {[1]}
        />
      </div>
    </div>
  );
};

export default React.memo(InmateTransaction);
